
<template>
  <el-dialog v-dialogDrag :visible.sync="currentVisible" :close-on-click-modal="!userInfo.isFirstLogin" :show-close="!userInfo.isFirstLogin" width="600px" title="修改密码" append-to-body @opened="onOpened">
    <el-alert v-if="userInfo.isFirstLogin" :closable="false" title="首次登陆必须修改初始密码，密码必须至少包含大小写字母、数字和特殊字符各一位。" type="warning" show-icon class="margin-bottom-20">
    </el-alert>
    <el-alert v-else-if="userInfo.isPwdDueSoon" :closable="false" title="密码即将过期请修改密码，密码必须至少包含大小写字母、数字和特殊字符各一位。" type="warning" show-icon class="margin-bottom-20">
    </el-alert>
    <el-alert v-else-if="userInfo.global_strongPasswordPolicy" :closable="false" title="密码必须至少包含大小写字母、数字和特殊字符各一位。" type="warning" show-icon class="margin-bottom-20">
    </el-alert>
    <el-form ref="form" :model="form" class="demo-form-inline w-400">
      <el-form-item v-if="isOrginPwd" :label-width="formLabelWidth" label="请输入原密码：">
        <el-input v-model="form.originPassword" :type="passwordType" auto-complete="off" :readonly="readonly"></el-input>
        <!-- <span class="show-pwd" @click="showPwd">
          <svg-icon :icon-class="passwordType=='password'?'eye':'eye-open'" />
        </span> -->
      </el-form-item>
      <el-form-item :label-width="formLabelWidth" label="请输入新密码：">
        <el-input v-model="form.password" :type="passwordType" auto-complete="off" :readonly="readonly"></el-input>
        <!-- <span class="show-pwd" @click="showPwd">
          <svg-icon :icon-class="passwordType=='password'?'eye':'eye-open'" />
        </span> -->
      </el-form-item>
      <el-form-item :label-width="formLabelWidth" label="输入确认密码：">
        <el-input v-model="form.password_repeat" :type="passwordType" auto-complete="off" :readonly="readonly"></el-input>
        <!-- <span class="show-pwd" @click="showPwd">
          <svg-icon :icon-class="passwordType=='password'?'eye':'eye-open'" />
        </span> -->
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button v-if="!userInfo.isFirstLogin" @click="currentVisible = false">取 消</el-button>
      <el-button type="primary" @click="modifypwd">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "order-barcode",
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    // 需要原密码
    isOrginPwd: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      id: "",
      passwordType: "password",
      form: {
        originPassword: "",
        password: "",
        password_repeat: ""
      },
      formLabelWidth: "150px",
      user_Id: "",
      userInfo: {},
      readonly: true
    };
  },
  computed: {
    currentVisible: {
      get: function() {
        return this.visible;
      },
      set: function(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  mounted() {
    this.userInfo = this.common.getUserInfo();
    this.user_Id = this.userInfo.user_Id;
    window.setTimeout(() => {
      this.readonly = false;
    }, 1000);
  },
  methods: {
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
    },
    setUser_Id(user_Id) {
      this.user_Id = user_Id;
    },
    modifypwd() {
      // 密码
      var password = this.form.password;
      if (password.length < 3) {
        this.$notify.error({
          title: "错误提示",
          message: "密码必须大于3位！"
        });
        return;
      }

      // 重复密码
      var password_repeat = this.form.password_repeat;
      if (password_repeat.length < 3) {
        this.$notify.error({
          title: "错误提示",
          message: "密码必须大于3位！"
        });
        return;
      } else if (password_repeat !== password) {
        this.$notify.error({
          title: "错误提示",
          message: "两次密码不一致！"
        });
        return;
      }

      const url = "/api/sys/user/modifyPwd";
      const params = {
        user_Id: this.user_Id,
        userPwd: password,
        repeatPassWord: password_repeat,
        originPassword: this.form.originPassword,
        isOrginPwd: this.isOrginPwd
      };
      var callback = res => {
        this.common.showMsg(res);
        if (res.result) {
          this.onOpened();
          this.currentVisible = false;
          if (this.$parent && this.$parent.editorOptions) {
            this.$parent.editorOptions.config.visible = false;
          }
          // 清除数据
          this.form.originPassword = "";
          this.form.password = "";
          this.form.password_repeat = "";
        }
      };
      this.common.ajax(url, params, callback, this.$refs.form);
    },
    onOpened() {
      this.readonly = true;
      window.setTimeout(() => {
        this.readonly = false;
      }, 1000);
    }
  }
};
</script>

<style lang="less" scoped>
@deep: ~">>>";

@{deep} .el-dialog__body {
  padding: 0px 10px;
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.show-pwd {
  position: absolute;
  right: 10px;
  top: 2px;
  font-size: 16px;
  color: $dark_gray;
  cursor: pointer;
  user-select: none;
}
</style>
